
import React, { useContext, useEffect, useState } from 'react'
import FileService from '../services/file';
import StorageService from '../services/storage';
import { Context } from "../AppContext";
import { ContextUI } from '../uiContext';
import ViewProcess from '../components/index/rasci/view-process';

const RasciProcessen = (props) => {
    const contextUI = useContext(ContextUI);
    const context = useContext(Context);
    const [rasci, setRasci] = useState();
    useEffect(() => {
        contextUI.setTitle('Werkprocessen / producten');
        contextUI.setSubTitle('');
       // contextUI.setShowBackButton(true);

        if (props.match.params.id) {
            let foundFile = context.info.Index.find(file => file.DPath === props.match.params.id);

            if (foundFile) {
                FileService.getContent(foundFile.DPath, StorageService.getStorageFileName(foundFile), true)
                    .then(content => {
                        let obj = (typeof content === 'string') ? JSON.parse(content) : content;
                        setRasci(obj);
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }, [])


    if (!rasci) return null;
    return (
        <div >
            <ViewProcess rasci={rasci}   selected={props.match.params.processid} selectedTaskID={props.match.params.taskid} history={props.history} fileID={props.match.params.id}/>
        </div>
    )
}
export default RasciProcessen
